import { TechnicalViewActionType } from "./constants";
import { getDropDownRange, defaultScenarioData, defaultSliderRange } from './utils'

const isDevUrl = window.location.href.includes("curve-demo");

export const getDefaultState = () => ({
  isInitialMount: true,
  toggle_about: true, // State for the topics toggle bar (open -> true , close -> false)
  toggle_about_hidden: false, // State for the topics toggle bar (open -> true , close -> false)
  chart: isDevUrl ? "central_az_water_use" : "colorado_river_access",
  scenario: "2024",
  all_scenarios: [], // Holds data related to all scenarios 
  alias_entity_id_mapping: {}, // Holds a map of entity names to ids for Colorado River Acess Map
  scenario_selected: { label: "Gradual Aridity Increase", value: 1 },
  big_river_policy: "Lorem Ipsum",
  area_chart_tab: { label: "State", value: 1 }, // tab_options details on AreaChart.js
  central_az_tab: "cities", //toggle between irrigation_disrict and cities
  polygon_map_tab: "curr_per_capita",
  polygon_map_tab1: "curr_per_capita",
  irrigation_district_selected: {
    name: "Salt River Valley Water Users Association",
    agriculture_id: 1,
  },
  irrigation_districts: [], // a list of irrigation districts
  irrigation_district_water_deliveries: {}, //District water deliveries for 3rd chart
  irrigation_district_water_use: {}, //District water use for 3rd chart
  cities: [], //Have a list of city names
  city_metrics: {}, // Hold selected city's metrics for 3rd charts
  city_metrics_gauge: {}, // Hold selected city's metrics for gauge charts
  city_selected_gauge: { name: "Phoenix", city_id: 44 },
  city_water_sources: {}, // Hold selected city's water sources
  cities_water_use: {}, // Hold all cities water use
  // city_selected: {},
  city_selected: {},
  previousMapSelection: 44,
  tribes: [],
  tribe_selected: { name: "San Carlos Apache Tribe", tribe_id: 52 },
  tribe_metrics: {},
  is_tribe: false,
  is_western: false,
  is_city: true, 
  industry_metrics: null,
  entitlement_year: 2024,
  slider_entitlement_year: 2024,
  entitlements_by_year: {},
  access_difference_range: {},
  entity_entitlements: {}, // Hold Co River Access for the entity (city selected on 5th chart)
  all_cities_metric: {},
  priority_entitlements: {}, //entitlements aggregated by priority pool
  all_cities_total_co_access: {},
  per_person_entitlement_difference: {}, //difference per capital for honeycomb chart
  western_arizona_entitlements: {},
  western_arizona_entities: [],
  western_arizona_selected: { name: "Bullhead City", entity_id: 116 },
  western_priority_entitlements: {},
  western_entity_entitlements: {},
  entity_header: ' ',
  sidebar_accordions: {
    colorado_river_access: {
      tap_water_sources: true,
      water_uses: true,
      about: true,
      entity: false,
      access_balance: true,
    },
    access_per_capita: {
      tap_water_sources: true,
      water_uses: true,
      about: true,
      entity: false,
    },
    central_az_water_use: {
      tap_water_sources: true,
      water_uses: true,
      about: true,
      entity: true,
    },
    colorado_river_water_access: {
      nia: true,
      indian: true,
      "m&i": true,
      p13: true,
      dcp_nia: true,
      leases_exchanges: true,
      about: true,
      entity: true,
    },
    water_use_versus_access: {
      availability: true,
      about: true,
      entity: true,
    },
  }, //holds open/closed status for each sidebar accordion
  slider_range: defaultSliderRange,
  scenarios: defaultScenarioData,
  selectedScenario: '2024-2028',
  entity_dropdown: [],
  mapZoom: 8,
  userLastSelectedMapState: {}

});

export default (state = getDefaultState(), action) => {
  switch (action.type) {
    case TechnicalViewActionType.SET_CHART:
      return setChartSelection(state, action);
    case TechnicalViewActionType.SET_SCENARIO:
      return setScenarioFilter(state, action);
    case TechnicalViewActionType.SET_ALL_SCENARIOS:
      return setAllScenarios(state, action);
    case TechnicalViewActionType.SET_SCENARIO_SELECTED:
      return setScenarioSelected(state, action);
    case TechnicalViewActionType.SET_IS_INITIAL_MOUNT:
        return setIsInitialMount(state, action);
    case TechnicalViewActionType.TOGGLE_ABOUT:
      return toggleAbout(state, action);
    case TechnicalViewActionType.TOGGLE_ABOUT_HIDDEN:
      return toggleAboutHidden(state, action);
    case TechnicalViewActionType.SET_AREA_CHART_TAB:
      return setAreaChartTab(state, action);
    case TechnicalViewActionType.RESET_SIDEBAR_ACCORDIONS:
      return resetSidebarAccordions(state, action);
    case TechnicalViewActionType.UPDATE_SIDEBAR_ACCORDIONS:
      return updateSidebarAccordions(state, action);
    // polygon map
    case TechnicalViewActionType.SET_POLYGON_MAP_TAB:
      return setPolygonMapTab(state, action);
    // case TechnicalViewActionType.RESET_SELECTED_AGRICULTURE:
    // agriculture and irrigation disrict
    case TechnicalViewActionType.SET_CENTRAL_AZ_TAB:
      return setCentralAZTab(state, action);
    case TechnicalViewActionType.RESET_SELECTED_AGRICULTURE:
      setCentralAZTab(state, action)
      return resetSelectedIrrigationDistrict(state, action);
    case TechnicalViewActionType.SET_ALL_IRRIGATION_DISTRICTS:
      return setAllIrrigationDistricts(state, action);
    case TechnicalViewActionType.SET_SELECTED_IRRIGATION_DISTRICT:
      return setSelectedIrrigationDistrict(state, action);
    case TechnicalViewActionType.SET_DISTRICT_WATER:
      return setDistrictWater(state, action);
    case TechnicalViewActionType.SET_DELIVERIES:
      return setDeliveries(state, action);
    // colorado river water access
    case TechnicalViewActionType.SET_ENTITY_ENTITLEMENTS:
      return setEntityEntitlements(state, action);
    case TechnicalViewActionType.SET_ENTITLEMENT_YEAR:
      return setEntitlementYear(state, action);
    case TechnicalViewActionType.SET_SLIDER_ENTITLEMENT_YEAR:
      return setSliderEntitlementYear(state, action);
    case TechnicalViewActionType.SET_ENTITLEMENTS_BY_YEAR:
      return setEntitlementsByYear(state, action);
    case TechnicalViewActionType.SET_ENTITLEMENTS_BY_YEAR_RANGE:
      return setAccessDifferenceRange(state, action);
    case TechnicalViewActionType.SET_PRIORITY_ENTITLEMENTS:
      return updatePriorityEntitlements(state, action);
    case TechnicalViewActionType.SET_PER_PERSON_ENTITLEMENT_DIFFERENCE:
      return setPerPersonEntitlementDifference(state, action);
    // cities
    case TechnicalViewActionType.SET_IS_CITY:
      return setIsCity(state, action);
    case TechnicalViewActionType.SET_ALL_CITIES:
      return setCities(state, action);
    case TechnicalViewActionType.SET_CITY_METRICS:
      return setCityMetrics(state, action);
    case TechnicalViewActionType.SET_SELECTED_CITY:
      return setSelectedCity(state, action);
    case TechnicalViewActionType.RESET_SELECTED_CITY:
      return resetSelectedCity(state, action);
    case TechnicalViewActionType.SET_PREVIOUS_MAP_SELECTION:
      return setPreviousMapSelection(state, action);
    case TechnicalViewActionType.SET_CITY_WATER_SOURCES:
      return setCityWaterSources(state, action);
    case TechnicalViewActionType.SET_ALL_CITY_WATER_USE:
      return setCitiesWaterUse(state, action);
    case TechnicalViewActionType.SET_CITY_POPULATION:
      return setCitiesPopulation(state, action);
    // cities gauge chart
    case TechnicalViewActionType.SET_CITY_METRICS_GAUGE:
      return setCityMetricsGauge(state, action);
    case TechnicalViewActionType.SET_SELECTED_CITY_GAUGE:
      return setSelectedCityGauge(state, action);
    case TechnicalViewActionType.RESET_SELECTED_CITY_GAUGE:
      return resetSelectedCityGauge(state, action);
    // industry
    case TechnicalViewActionType.SET_INDUSTRY_METRICS:
      return setIndustryMetrics(state, action);
    // tribes
    case TechnicalViewActionType.SET_ALL_TRIBES:
      return setTribes(state, action);
    case TechnicalViewActionType.SET_SELECTED_TRIBE:
      return setSelectedTribe(state, action);
    case TechnicalViewActionType.SET_TRIBE_METRICS:
      return setTribeMetrics(state, action);
    case TechnicalViewActionType.SET_IS_TRIBE:
      return setIsTribe(state, action);
    case TechnicalViewActionType.SET_BIG_RIVER_POLICY:
      return setBigRiverPolicyFilter(state, action);
    case TechnicalViewActionType.SET_ALL_CITY_METRICS:
      return setAllCitiesMetrics(state, action);
    // Western arizona
    case TechnicalViewActionType.SET_WESTERN_ARIZONA_ENTITLEMENTS:
      return setWesternArizonaEntitlements(state, action);
    case TechnicalViewActionType.SET_WESTERN_ARIZONA_ENTITIES:
      return setWesternArizonaEntities(state, action);
    case TechnicalViewActionType.SET_WESTERN_ARIZONA_SELECTED:
      return setSelectedWesternArizona(state, action);
    case TechnicalViewActionType.SET_IS_WESTERN:
      return setWestern(state, action);
    case TechnicalViewActionType.CHANGE_SLIDER_RANGE:
      return setSlider(state, action)
    case TechnicalViewActionType.SET_WESTERN_ARIZONA_PRIORITY_ENTITLEMENTS:
      return setWesternArizonaPriorityEntitlements(state, action);
    case TechnicalViewActionType.SET_WESTERN_ARIZONA_ENTITY_ENTITLEMENTS:
      return setWesternArizonaEntityEntitlements(state, action);
    case TechnicalViewActionType.SET_MAP_ZOOM:
      return setEntityMapZoom(state, action);
    case TechnicalViewActionType.SET_ENTITY_HEADER:
      return setEntityHeader(state, action);
    case TechnicalViewActionType.SET_USER_LAST_SELECTED_MAP_STATE:
      return setUserLastSelectedMapState(state, action);
    default:
      return state;
  }
};

const setSlider = (state, action) => {
  let [start, end] = action.data.split('-')
  let result = []
  for (let index = parseInt(start); index <= parseInt(end); index++) {
    result.push({ label: index.toString(), value: index })
  }
  return {
    ...state,
    selectedScenario: action.data,
    slider_range: result,
  }
}

const setEntityHeader = (state, action) => {
  const { data, id } = action
  var entityFound = data?.find((entity) => entity?.value === id);
  return {
    ...state, 
    entity_header: entityFound ? entityFound?.label : state.entity_header
  }
}

const setWestern = (state, { is_western }) => {
  return {
    ...state,
    is_western
  };
};

const setIsCity = (state, {value}) => {
  return {
    ...state,
    is_city: value,
  };
};

const setWesternArizonaEntities = (state, { western_arizona_entities }) => {
  western_arizona_entities.forEach(function (entity) {
    state.alias_entity_id_mapping[entity.label] = entity.value;
  });
  return {
    ...state,
    western_arizona_entities
  };
};

const setWesternArizonaEntitlements = (state, { western_arizona_entitlements }) => {
  return {
    ...state,
    western_arizona_entitlements
  };
}

const setBigRiverPolicyFilter = (state, { big_river_policy }) => {
  return {
    ...state,
    big_river_policy,
  };
};

const setIsInitialMount = (state, { value }) => {
  return {
    ...state,
    isInitialMount: value,
  };
};


const toggleAbout = (state, { toggle }) => {
  if (toggle !== undefined) {
    return {
      ...state,
      toggle_about: toggle,
    };
  }
  else {
    return {
      ...state,
      toggle_about: !state.toggle_about,
    };
  }
};

const toggleAboutHidden = (state, action) => {
  // console.log("LOG HIDDEN", state, action)
  return {
    ...state,
    toggle_about_hidden: !state.toggle_about_hidden,
  };
};

const setChartSelection = (state, { chart }) => {
  return {
    ...state,
    chart,
  };
};

const setScenarioFilter = (state, { scenario }) => {
  return {
    ...state,
    scenario,
  };
};

const setAllScenarios = (state, { scenarios }) => {
  return {
    ...state,
    all_scenarios: scenarios,
  };
};

const setScenarioSelected = (state, { scenario }) => {
  return {
    ...state,
    scenario_selected: scenario,
  };
};

const setAreaChartTab = (state, { area_chart_tab }) => {
  return {
    ...state,
    area_chart_tab,
  };
};

const setPolygonMapTab = (state, { polygon_map_tab }) => {
  return {
    ...state,
    polygon_map_tab,
  };
};

const setCentralAZTab = (state, { central_az_tab }) => {
  return {
    ...state,
    central_az_tab,
  };
};

const resetSelectedIrrigationDistrict = (state) => {
  return {
    ...state,
    irrigation_district_selected: {
      name: "Salt River Valley Water Users Association",
      irrigation_district_id: 14,
    },
  };
};

const setAllIrrigationDistricts = (state, { irrigation_districts }) => {
  return {
    ...state,
    irrigation_districts,
  };
};

const setSelectedIrrigationDistrict = (state, { district_selected }) => {
  if (district_selected !== undefined) {
    return {
      ...state,
      irrigation_district_selected: {
        name: district_selected.label,
        agriculture_id: district_selected.value,
      },
    };
  } else return state;
};

const setDistrictWater = (state, { district_water }) => {
  return {
    ...state,
    irrigation_district_water_use: district_water,
  };
};

const setDeliveries = (state, { deliveries }) => {
  return {
    ...state,
    irrigation_district_water_deliveries: deliveries,
  };
};

const setCities = (state, { cities }) => {
  cities.forEach(function (city) {
    state.alias_entity_id_mapping[city.label] = city.value;
  });
  return {
    ...state,
    cities,
  };
};

const setCityMetrics = (state, { city_metrics }) => {
  return {
    ...state,
    city_metrics,
  };
};

const setCityWaterSources = (state, { city_water_sources }) => {
  return {
    ...state,
    city_water_sources,
  };
};

const setCitiesWaterUse = (state, { cities_water_use }) => {
  return {
    ...state,
    cities_water_use,
  };
};

const setCitiesPopulation = (state, { population }) => {
  return {
    ...state,
    population,
  };
};

const setSelectedCity = (state, { city_selected }) => {
  if (city_selected !== undefined) {
    return {
      ...state,
      city_selected: {
        name: city_selected.label,
        city_id: city_selected.value,
      },
    };
  } else return state;
};

const resetSelectedCity = (state) => {
  return {
    ...state,
    city_selected: { name: "Phoenix", city_id: 1 },
  };
};

const setPreviousMapSelection = (state, { previousMapSelection }) => {
  return {
    ...state,
    previousMapSelection,
  };
};

const setEntityEntitlements = (state, { entitlements }) => {
  return {
    ...state,
    entity_entitlements: entitlements,
  };
};


const setAllCitiesMetrics = (state, { all_cities_metric }) => {
  return {
    ...state,
    all_cities_metric,
  };
};

const setTribes = (state, { tribes }) => {
  tribes.forEach(function (tribe) {
    state.alias_entity_id_mapping[tribe.label] = tribe.value;
  });
  return {
    ...state,
    tribes,
  };
};

const setSelectedTribe = (state, { tribe_selected }) => {
  return {
    ...state,
    tribe_selected: {
      name: tribe_selected.label,
      tribe_id: tribe_selected.value,
    },
  };
};

const setSelectedWesternArizona = (state, { western_arizona_selected }) => {
  return {
    ...state,
    western_arizona_selected: {
      name: western_arizona_selected.label,
      entity_id: western_arizona_selected.value,
    },
  };
};

const setWesternArizonaPriorityEntitlements = (state, { western_priority_entitlements }) => {
  return {
    ...state,
    western_priority_entitlements,
  };
};

const setWesternArizonaEntityEntitlements = (state, { western_entity_entitlements }) => {
  return {
    ...state,
    western_entity_entitlements,
  };
};

const setTribeMetrics = (state, { tribe_metrics }) => {
  return {
    ...state,
    tribe_metrics,
  };
};

const setIsTribe = (state, { value }) => {
  return {
    ...state,
    is_tribe: value,
  };
};

const setEntitlementYear = (state, { year }) => {
  return {
    ...state,
    entitlement_year: year,
  };
};

const setSliderEntitlementYear = (state, { year }) => {
  return {
    ...state,
    slider_entitlement_year: year,
  };
};

const setEntitlementsByYear = (state, { entitlements_by_year }) => {
  return {
    ...state,
    entitlements_by_year,
  };
};

const setAccessDifferenceRange = (state, { access_difference_range }) => {
  return {
    ...state,
    access_difference_range,
  };
};

const updatePriorityEntitlements = (state, { priority_entitlements }) => {
  return {
    ...state,
    priority_entitlements,
    entity_dropdown: getDropDownRange(priority_entitlements)
  };
};

const setPerPersonEntitlementDifference = (
  state,
  { entitlement_difference }
) => {
  return {
    ...state,
    per_person_entitlement_difference: entitlement_difference,
  };
};

const setSelectedCityGauge = (state, { city_selected_gauge }) => {
  if (city_selected_gauge !== undefined) {
    return {
      ...state,
      city_selected_gauge: {
        name: city_selected_gauge.label,
        city_id: city_selected_gauge.value,
      },
    };
  } else return state;
};

const resetSelectedCityGauge = (state) => {
  return {
    ...state,
    city_selected_gauge: { name: "Phoenix", city_id: 1 },
  };
};

const setCityMetricsGauge = (state, { city_metrics_gauge }) => {
  return {
    ...state,
    city_metrics_gauge,
  };
};

const setIndustryMetrics = (state, { industry_metrics }) => {
  return {
    ...state,
    industry_metrics,
  };

};

const resetSidebarAccordions = (state) => {
  return {
    ...state,
    sidebar_accordions: {
      colorado_river_access: {
        tap_water_sources: true,
        water_uses: true,
        about: true,
        entity: true,
        access_balance: true,
      },
      access_per_capita: {
        tap_water_sources: true,
        water_uses: true,
        about: true,
        entity: true,
      },
      central_az_water_use: {
        tap_water_sources: true,
        water_uses: true,
        about: true,
        entity: true,
      },
      colorado_river_water_access: {
        nia: true,
        indian: true,
        "m&i": true,
        p13: true,
        dcp_nia: true,
        leases_exchanges: true,
        about: true,
        entity: true,
      },
      water_use_versus_access: {
        availability: true,
        about: true,
        entity: true,
      },
    },
  };
};

const updateSidebarAccordions = (state, { accordion }) => {
  if (state.sidebar_accordions[state.chart].hasOwnProperty(accordion)) {
    state.sidebar_accordions[state.chart][accordion] = !state.sidebar_accordions[state.chart][accordion];
  }
  else {
    state.sidebar_accordions[state.chart][accordion] = true;
  }
  // return {
  //   ...state,
  //   sidebar_accordions: {},
  // };
  return state;
};

const setEntityMapZoom = (state, { mapZoom }) => {
  return {
    ...state,
    mapZoom,
  }
}

const setUserLastSelectedMapState = (state, { mapState }) => {
 
  return {
    ...state,
    userLastSelectedMapState: {
      center: mapState.center,
      zoom: mapState.zoom

    },
  };
}

